export default __webpack_public_path__ + "static/media/v4.16b8ef84.png";